import React from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import {withTheme} from 'styled-components/macro';
import Column from '../../Column';
import {_Divider, _Title} from '../../Tile';
import Row from '../../Row';
import Icon from '../../Icon';
import {getBlackWhiteWithOpacity} from '../../../utils/colors';

const {detect} = require('detect-browser');
const browser = detect();
Modal.setAppElement('#circleblack-root');

const BaseModal = ({title, onClose, theme, children, size = 'md'}) => {
  let contentMaxWidth = '600px';
  if (size === 'sm') {
    contentMaxWidth = '300px';
  } else if (size === 'lg') {
    contentMaxWidth = '1000px';
  }

  return <Modal
    isOpen={true}
    onRequestClose={onClose}
    style={{
      overlay: {
        backgroundColor: 'rgba(0,0,0,0.5)',
        backdropFilter: 'blur(2px)',
        zIndex: 99,
      },
      content: {
        height: browser?.name === 'firefox' ? '-moz-fit-content' : 'fit-content',
        border: 'none',
        boxShadow: theme.neumorphic ? 'inset 1px 1px 0px 0 rgba(255, 255, 255, 0.2), inset -1px -1px 0px 0 rgba(0, 0, 0, 0.5), 2px 2px 5px 2px rgba(0, 0, 0, 0.4)' : '1px 2px 8px rgb(0 0 0 / 50%)',
        inset: '40px 10px 0 10px',
        marginLeft: 'auto',
        marginRight: 'auto',
        minWidth: '300px',
        maxHeight: 'calc(100vh - 50px)',
        overflow: 'hidden',
        transform: 'translate(0, 0)',
        boxSizing: 'border-box',
        backgroundImage: theme.neumorphic ? theme.tileBackgroundColor : 'linear-gradient(to bottom right, rgba(0, 29, 40, 0.3), rgba(9, 16, 0, 0.3))',
        borderRadius: '12px',
        display: 'flex',
        flexDirection: 'column',
        padding: '5px',
        paddingBottom: '10px',
        backgroundColor: theme.tileBackgroundColor,
        maxWidth: contentMaxWidth,
      },
    }}>
    <Row width={'100%'} justifySubRow={'space between'} wrap={false}>
      <div style={{width: '30px'}}>&nbsp;</div>
      <_Title>{theme.neumorphic ? title.toUpperCase() : title}</_Title>
      <Icon svg={'close'} action={onClose} color={getBlackWhiteWithOpacity(0.7)}/>
    </Row>
    <_Divider/>
    <Column minHeight={'50px'} width={'100%'} layout={{grow: 1}} alignItems={'stretch'}>
      {children}
    </Column>
  </Modal>;
};

export default withTheme(BaseModal);

BaseModal.propTypes = {
  /**
   * Title of modal
   */
  title: PropTypes.string.isRequired,
  /**
   * Function to call on Close
   */
  onClose: PropTypes.func.isRequired,
  /**
   * Children of component
   */
  children: PropTypes.node.isRequired,
  /**
   * Optional size of modal to specify width and max-width (sm = 300px, md = 500px, lg = 800px)
   */
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  theme: PropTypes.object,
};
